export const FONT_NORMAL_ANDROID = "%NORMAL%"
export const FONT_LARGE_ANDROID = "%LARGE%"
export const FONT_MEDIUM_ANDROID = "%MEDIUM%"
export const FONT_SMALL_ANDROID = "%SMALL%"
export const ALIGN_CENTER_ANDROID = "%CENTER%"
export const ALIGN_LEFT_ANDROID = "%LEFT%"
export const ALIGN_RIGHT_ANDROID = "%RIGHT%"
